import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AuthService } from "../../common/services/auth.service";
import { ModalService } from "../../common/services/modal.service";

@Component({
    selector: "app-login",
    templateUrl: "./login.component.html",
    styleUrls: ["./login.component.scss"],
})
export class LoginComponent implements OnInit {
    email: string = "";
    password: string = "";
    loading: boolean = false;

    constructor(
        private authService: AuthService,
        private modal: ModalService,
        private router: Router
    ) {}

    ngOnInit(): void {}

    login() {
        if (this.loading) return;
        if (!this.email || !this.password) {
            this.modal.openValidationDialog(
                "warning",
                "خطأ",
                "يرجي ملئ البيانات المطلوبة"
            );
            return;
        }

        this.loading = true;
        this.authService.login(this.email, this.password).subscribe(
            (res) => {
                this.loading = false;
                if (res["success"] == true) {
                    this.modal.snackMessage(res["message"]);
                    this.router.navigate(["/"]);
                } else {
                    this.modal.snackMessage(res["message"]);
                }
            },
            (error) => {
                this.loading = false;
                this.modal.snackMessage(error["error"]["error"]);
            }
        );
    }
}
